
export const COLUMN_SETTINGS = {
  1: '单列',
  2: '双列',
  3: '三列',
}
export const EXISTENCE_COMPONENTS = ['radio', 'checkbox', 'blank', 'section']